import { Switch } from 'antd'
import React, { useEffect, useState } from 'react'
import { withTranslation } from 'react-i18next'

const SwitchType = (props) => {

    const {
        t,
        switchTypeUpdate,
        index,
        data
    } = props

    const [isAdult, setIsAdult] = useState(data.numOfAdult > data.numOfChild)

    const onChange = (value) => {
        setIsAdult(!isAdult)
        switchTypeUpdate(value, index)
    }

    useEffect(() => {
        switchTypeUpdate(data.numOfAdult > data.numOfChild, index)
    }, [])

    return (
        <Switch
            checkedChildren={t('item.infoRedeem.transportation.adult')}
            unCheckedChildren={t('item.infoRedeem.transportation.children')}
            checked={isAdult}
            onChange={value => onChange(value, index)}
        />
    )
}

export default SwitchType